export default __webpack_public_path__ + "static/media/icw-sod.1e9b1f9a.jpg";